import {signIn, signOut, useSession} from "next-auth/react";
import {useRouter} from "next/router";
import {getToken} from "next-auth/jwt";

const AuthLayout = ({children}: { children: React.ReactNode }) => {

  const router = useRouter()
  const session = useSession({
    required: true,
    onUnauthenticated() {
      signIn()
      // The user is not authenticated, handle it here.
    },
  })
  return <>
    {children}
  </>

}

export default AuthLayout

